export default __webpack_public_path__ + "static/media/_Vierbeiner.f35e3568.png";